import { path } from 'ramda'

export const preview = state => path(['cms', 'preview'], state)

export const cmsEnvironment = state => path(['cms', 'cmsEnvironment'], state)
